import { DialogService } from '../../shared/services/dialog.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseService } from '../../shared/services/base.service';
import { AppMessages } from '../../shared/constants/messages';
import { AppConstants } from '../../shared/constants/constants';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { Utility } from '../../common/utility';
import { ValidationService } from '../../shared/services/validation.service';
import { FluBookingService } from './flu-vaccine.service';

@Component({
  selector: 'booking-detail-popup',
  templateUrl: 'booking-detail-popup.component.html',
  providers: [FluBookingService]
})
export class BookDetailPopupComponent implements OnInit {
  public bookingDetailForm: FormGroup;
  public isSuccess: boolean;
  public patientList = [{ id: '123', name: 'aaa' }, { id: '24a', name: 'bbb' }];
  constructor(
    public utility: Utility,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialogRef: MatDialogRef<BookDetailPopupComponent>,
    public dialogService: DialogService,
    public fluBookingService: FluBookingService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.patientList = this.data['patientList'] || [];
    this.createForm();
  }

  createForm() {
    this.bookingDetailForm = this.formBuilder.group({
      // patientName: ['', [Validators.required]],
      // email: ['', [Validators.required, ValidationService.isValidEmail]],
      patientId: ['', [Validators.required]],
      bookingTime: [this.data.time]
    });
  }

  onSubmit() {
    if (this.bookingDetailForm.valid && this.bookingDetailForm.dirty) {
      const confirmMessage = Utility.stringFormat(AppMessages.booking.fluBookingConfirm, [this.data.time]);
      this.dialogService.openConfirmationDialog({ message: confirmMessage }).subscribe(
        confirm => {
          if (confirm) {
            const time = this.data.time.split(' - ');
            const param = {
              bookingid: this.data.bookingId,
              startTime: this.data.startTime,
              clientStartTime: this.data.clientStartTime,
              bookingStaffId: this.data.staffId,
              // email: this.bookingDetailForm.controls.email.value
              bookingMemberId: this.bookingDetailForm.controls.patientId.value
            };
            this.fluBookingService.updateFluBooking(param).subscribe(
              (result) => {
                if (result) {
                  const data = result.json();
                  // const item = {
                  //   id: '2',
                  //   title: 'New User', // booking ref or patient name
                  //   class: 'Flu',
                  //   start: '2018-01-09T02:15:00',
                  //   end: '2018-01-09T02:30:00',
                  //   readOnly: true
                  // };
                  this.dialogService.openSuccessDialog({ message: data.message.message });
                  this.isSuccess = true;
                  this.onCloseDialog(data.result);
                }
              },
            );
          }
        });
    }
  }

  onCloseDialog(param) {
    this.dialogRef.close(param);
  }

}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/flu-vaccine/booking-detail-popup.component.ts